/**
 * @param {MediaSubFile} mediaSubFile
 * @return {string}
 */
/** @deprecated Prefer to use "getFrameUrl" */
export default (mediaSubFile) => {
  return mediaSubFile.externalLink.replace('vindex.json', `f${mediaSubFile.firstFrame}.jpg`);
};
